import { ListItem, ListItemButton, Typography, useTheme } from "@mui/material";
import { Link as LinkRouter, useLocation } from "react-router-dom";

type ItemMenuMbProps = {
  children?: React.ReactNode;
  primary?: string;
  secondary?: string;
  onClick: () => void;
  to: string;
};
export const ItemMenuMb = ({
  children,
  primary,
  secondary,
  onClick,
  to,
}: ItemMenuMbProps) => {
  const location = useLocation();
  const theme = useTheme();
  return (
    <ListItem disablePadding>
      <ListItemButton
        TouchRippleProps={{
          style: {
            color: theme.palette.primary[700],
          },
        }}
        component={LinkRouter}
        to={to}
        onClick={onClick}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor:
            to === location.pathname ? theme.palette.primary.main : "",
          paddingBlock: secondary ? 0 : 3,
          gap: 2,
          m: 1,
        }}
      >
        {children}
        {primary ? (
          <Typography
            sx={{
              color: to === location.pathname ? theme.palette.primary[800] : "",
            }}
            variant="subtitle2"
            flex={1}
          >
            {primary}
          </Typography>
        ) : (
          <Typography
            variant="overline"
            color="textSecondary"
            sx={{ textTransform: "capitalize", marginInline: 4 }}
          >
            {secondary}
          </Typography>
        )}
      </ListItemButton>
    </ListItem>
  );
};
